export default __webpack_public_path__ + "images/0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22.png";